var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admins"},[_c('Form',{attrs:{"model":_vm.model,"schema":_vm.schema,"submit-text":"Test"},on:{"submit:success":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }